export default __webpack_public_path__ + "static/media/icon-arrow-button.7810050b.svg";